import { Provider } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { AddTeammatesDialogData } from '@ninety/platform/models/user/add-teammates-dialog-data';
import { ADD_TEAMMATES_DIALOG, DialogOpener } from '@ninety/platform/state';
import { AddTeammatesDialogComponent } from '@ninety/ui/core';

/**
 * Binds the add-teammates dialog-opener token (DEV-26105 T6c, Option B) to a factory that opens the
 * concrete `AddTeammatesDialogComponent` via `MatDialog`. `UsersStateEffects` lives in `platform/state`
 * and injects only the token; this composition-root wiring is the single place that depends on both the
 * token and the `shared/ui/core` component, so the `platform/state -> shared/ui/core` edge stays
 * severed. The effect's other dialog (`ConfirmDialogComponent`) reuses `CONFIRM_DIALOG`, already bound
 * in `billing-dialog.providers.ts`. Mirrors `auth-dialog.providers.ts` / `billing-dialog.providers.ts`.
 */
export const USERS_DIALOG_PROVIDERS: Provider[] = [
  {
    provide: ADD_TEAMMATES_DIALOG,
    useFactory:
      (matDialog: MatDialog): DialogOpener<AddTeammatesDialogData> =>
      (config?: MatDialogConfig<AddTeammatesDialogData>) =>
        matDialog.open<unknown, AddTeammatesDialogData>(AddTeammatesDialogComponent, config),
    deps: [MatDialog],
  },
];
